import React from 'react'
import { useEffect, useState } from 'react'
import { Cookies } from 'react-cookie'
import useWindowDimensions from '../../hooks/useWindowDimensions'
import { CommandPaletteSearchLocal } from '../CommandPaletteSearchLocal'
import { LOCATION, NAME_OF_EMPTY } from '../../constants/storageNames'
import { isValidStr } from '../../common_functions'

const defaultTextSelectLocal = 'Selecione sua localização'
interface LocationData {
  city: string
  region: string
  country: string
  ip: string
}

export function SelectLocal() {
  const cookies = new Cookies()
  const locationSessionStorage = sessionStorage.getItem(LOCATION)
  const [location, setLocation] = useState(
    isValidStr(locationSessionStorage) && locationSessionStorage != NAME_OF_EMPTY
      ? locationSessionStorage
      : defaultTextSelectLocal
  )
  const allowLocation = useState(cookies.get('location'))
  const [latitudeAux, setLatitudeAux] = useState(0)
  const [longitudeAux, setLongitudeAux] = useState(0)
  const [select, setSelect] = useState(false)
  const [widthSelectLocal, setWidthSelectLocal] = useState<string>('auto')
  const [manualLocation, setManualLocation] = useState(false)

  const [locationData, setLocationData] = useState<LocationData | null>(null)
  const [loading, setLoading] = useState<boolean>(true)
  const [error, setError] = useState<string | null>(null)

  // useEffect(() => {
  //   if (locationSessionStorage == undefined || locationSessionStorage == defaultTextSelectLocal) {
  //     navigator.geolocation.getCurrentPosition((pos) => {
  //       const { latitude, longitude } = pos.coords
  //       setLongitudeAux(longitude)
  //       setLatitudeAux(latitude)
  //     })
  //   }
  // }, [window.location.href])

  // const getLocation = () => {
  //   if (!manualLocation && allowLocation && width > 769) {
  //     if (!isValidStr(locationSessionStorage) || locationSessionStorage == null || locationSessionStorage == defaultTextSelectLocal) {
  //       fetch(
  //         `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitudeAux},${longitudeAux}&key=AIzaSyBMJPirDqc93mEN0kEGA7f7jvfkZp-CcXc`
  //       )
  //         .then((res) => res.json())
  //         .then((data) => {
  //           let locationAux = `${data.results[0].address_components[1].long_name}, ${data.results[0].address_components[2].short_name}`
  //           setLocation(locationAux)
  //           sessionStorage.setItem(LOCATION, locationAux)
  //         })
  //     } else {
  //       if(locationSessionStorage != NAME_OF_EMPTY) setLocation(locationSessionStorage)
  //     }
  //   }
  // }

  useEffect(() => {
    const fetchLocationData = async () => {
      try {
        const ipResponse = await fetch('https://api.ipify.org?format=json')
        if (!ipResponse.ok) {
          throw new Error('Falha ao obter o IP')
        }
        const ipData = await ipResponse.json()
        const ip = ipData.ip
        const locationResponse = await fetch(`https://ipapi.co/${ip}/json/`)
        if (!locationResponse.ok) {
          throw new Error('Falha ao obter a localização')
        }
        const locationData = await locationResponse.json()
        const { city, region, country } = locationData
        setLocationData({ city, region, country, ip })
      } catch (err) {
        setError('Erro ao obter localização.')
      } finally {
        setLoading(false)
      }
    }

    if (locationSessionStorage == undefined || locationSessionStorage == defaultTextSelectLocal) {
      fetchLocationData()
    }
  }, [])

  useEffect(() => {
    if ((locationSessionStorage == undefined || locationSessionStorage == defaultTextSelectLocal) && locationData != undefined) {
      setLocation(`${locationData.city}, ${locationData.region}`)
      sessionStorage.setItem(LOCATION, `${locationData.city}, ${locationData.region}`)
    }
  }, [locationData])

  const handleManualLocation = (val: string) => {
    setManualLocation(true)
    setLocation(val == NAME_OF_EMPTY ? defaultTextSelectLocal : val)
    setSelect(false)
    sessionStorage.setItem(LOCATION, val)
    window.location.reload()
  }

  const handleSelect = () => {
    setSelect(!select)
    // getLocation()
  }

  useEffect(() => {
    let loadingHTML = document.querySelector('.app-loading') as HTMLElement
    if (loadingHTML == undefined && isValidStr(location)) {
      let dropDownMenuHTML = document.querySelector('.dropdowns-menu') as HTMLElement
      if (dropDownMenuHTML != undefined) {
        let positionDrodownMenuX = dropDownMenuHTML.children[1].getBoundingClientRect().x
        let pinLocalHTML = document.querySelector('#selectLocalPin') as HTMLElement
        if (pinLocalHTML != undefined) {
          let pinLocalWidth = pinLocalHTML.clientWidth
          //pegando a posicao final
          let pinLocalCalc = pinLocalHTML.getBoundingClientRect().x + pinLocalHTML.clientWidth
          if (pinLocalCalc > positionDrodownMenuX) {
            let betweenCalc = pinLocalCalc - positionDrodownMenuX
            let paddingPx = 10
            let widthCalc = pinLocalWidth - betweenCalc - paddingPx
            setWidthSelectLocal(`${widthCalc}px`)
          }
        }
      }
    }
  }, [document.querySelector('.container-loading'), location])

  return (
    <>
      <button
        className="text-xl font-semibold text-glemo-blue absolute left-12"
        id="selectLocalPin"
        onClick={handleSelect}
        style={{ width: widthSelectLocal }}
      >
        <h5 className="truncate ...">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="27"
            fill="#0059ff"
            className="inline-flex -mt-1 me-2"
            viewBox="0 0 256 256"
          >
            <path d="M128,16a88.1,88.1,0,0,0-88,88c0,75.3,80,132.17,83.41,134.55a8,8,0,0,0,9.18,0C136,236.17,216,179.3,216,104A88.1,88.1,0,0,0,128,16Zm0,56a32,32,0,1,1-32,32A32,32,0,0,1,128,72Z"></path>
          </svg>
          <span>{location}</span>
        </h5>
      </button>
      {select && (
        <CommandPaletteSearchLocal changeInput={(input: string) => handleManualLocation(input)} />
      )}
    </>
  )
}
